export const sendMetrik = (type, value) => {
    window.ym(97854620, type, value);
}